/* src/app/layouts/login-layout/login-layout.component.scss */
.sidenav {
  height: 100%;
  background-color: #2daae1;
  overflow-x: hidden;
  padding-top: 20px;
}
.logo-box {
  background: #FFFFFF;
  padding: 20px;
  text-align: center;
}
.main {
  padding: 0px 10px;
}
@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
}
@media screen and (max-width: 450px) {
  .login-form {
    margin-top: 10%;
  }
  .register-form {
    margin-top: 10%;
  }
}
@media screen and (min-width: 768px) {
  .main {
    margin-left: 40%;
  }
  .sidenav {
    width: 40%;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
  }
  .login-form {
    margin-top: 80%;
  }
  .register-form {
    margin-top: 20%;
  }
}
.login-main-text {
  margin-top: 20%;
  padding: 60px;
  color: #fff;
}
.login-main-text h2 {
  font-weight: 300;
}
.btn-primary {
  border: solid 1px #2daae1;
  background-color: #2daae1 !important;
  color: #fff;
}
.btn-link {
  color: #2daae1;
}
/*# sourceMappingURL=login-layout.component.css.map */
